module.exports = __webpack_public_path__ + "img/removeimages-green.3952848b.svg";